import { Navigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { RootState } from "../../redux/store";
import { useEffect, useState } from "react";

interface PrivateRouteProps {
  children: JSX.Element;
  allowedRoles: string[];
}

const PrivateRoute = ({ children, allowedRoles }: PrivateRouteProps) => {
  const userRole = useSelector((state: RootState) => state?.authentication?.userRole);
  const [shouldRedirect, setShouldRedirect] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      if (!userRole) {
        setShouldRedirect(true);
      }
    }, 5000); // Wait 5 seconds before redirecting

    return () => clearTimeout(timer); // Cleanup on unmount
  }, [userRole]);

  // console.log(userRole, allowedRoles);

  if (shouldRedirect || (userRole && !allowedRoles.includes(userRole))) {
    return <Navigate to="/" replace />;
  }

  return children;
};

export default PrivateRoute;
